import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { SnackbarApiService } from '../helpers/snackbar-api.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private snackbarApi: SnackbarApiService) {}

  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => this.handleApiError<T>(request, error)));
  }

  private handleApiError<T>(request: HttpRequest<T>, error: HttpErrorResponse): Observable<HttpEvent<T>> {
    // TODO: temporary solution for skipping error handling on specific URLs
    const skippableUrls: string[] = ['/instructor/me/registration'];
    if (skippableUrls.some(url => request.url.endsWith(url)) && error.status === HttpStatusCode.Unauthorized) {
      return throwError(() => error);
    }

    if (
      error.status === HttpStatusCode.NotFound ||
      error.status === HttpStatusCode.BadRequest ||
      error.status === HttpStatusCode.PayloadTooLarge ||
      error.status === HttpStatusCode.Conflict ||
      error.status === HttpStatusCode.Unauthorized ||
      error.status === HttpStatusCode.BadRequest ||
      error.status === HttpStatusCode.Forbidden
    ) {
      this.showErrorMessage(error);
    }

    return throwError(() => error);
  }

  private showErrorMessage(error: HttpErrorResponse) {
    if (typeof error.error.message === 'string') {
      return this.snackbarApi.failure(error.error.message);
    }
    if (Array.isArray(error.error.message) && error.error.message.length > 0) {
      if (typeof error.error.message[0] === 'object') {
        const msg = Object.values(error.error.message[0])[0];
        if (Array.isArray(msg) && msg[0]) {
          return this.snackbarApi.failure(msg[0]);
        }
      }
    }
    return this.snackbarApi.failure(`${error.statusText}. An unexpected error occurred`);
  }
}
